import React from "react";
import PropTypes from "prop-types";
import cname from "../../style.module.scss";

export function Tabs(props) {
  return <ul className={cname.tabs}>{props.children}</ul>;
}

Tabs.propTypes = {
  /**
   * List of tabs to enter section
   */
  children: PropTypes.arrayOf(PropTypes.element),
};

export function Tab(props) {
  const getCname = () => {
    let className = cname.tab;
    if (props.current) {
      className += ` ${cname.current}`;
    }
    return className;
  };
  const onClick = () => props.onClick(props.label);

  return (
    <li
      className={getCname()}
      role="option"
      aria-selected={props.label}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
    >
      {props.label}
    </li>
  );
}

Tab.propTypes = {
  /**
   * Label of the tab
   */
  label: PropTypes.string,
  /**
   * Boolen set if tab is current
   */
  current: PropTypes.bool,
  /**
   * Callback for when a tab is clicked
   */
  onClick: PropTypes.func,
};
